import React, { useState, useEffect, useCallback } from 'react';
import classnames from 'classnames';

import './WpBackdrop.scss';

export interface Props {
  animation?: boolean;
  onClick?(): void;
  transparent?: boolean;
}

const classNamePrefix = 'WpBackdrop';

const WpBackdrop: React.FC<Props> = ({ animation = true, onClick, transparent = false }: Props) => {
  const [isBackdropRender, setIsBackdropRender] = useState(!animation);
  const classes = classnames(
    classNamePrefix,
    { [`${classNamePrefix}--open`]: isBackdropRender },
    transparent && `${classNamePrefix}--transparent`
  );

  useEffect(() => {
    if (animation) setTimeout(() => setIsBackdropRender(true));
  }, []);

  const handleClick = useCallback(() => {
    if (onClick) onClick();
  }, [onClick]);

  return <div className={classes} onClick={handleClick} />;
};

export default WpBackdrop;
